module.exports = __webpack_public_path__ + "static/img/jb1.a524dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/jb1.png
// module id = DlUJ
// module chunks = 0